<div class="flex flex-col space-y-2 items-center">
  <h3 class="font-semibold text-base">{{ title() }}</h3>
  <div class="w-full" echarts [options]="options()"></div>
</div>
